export default "__VITE_ASSET__735b295b__"